import React from 'react';
import { FiBarChart2 } from 'react-icons/fi';
import './ContextualAnalytics.css';

function AnalyticsButton({ onClick, insightCount, isOpen }) {
  return (
    <button
      className={`analytics-fab ${isOpen ? 'active' : ''}`}
      onClick={onClick}
      aria-label="Open Analytics"
    >
      <FiBarChart2 size={24} />
      {insightCount > 0 && !isOpen && (
        <span className="analytics-badge">{insightCount}</span>
      )}
    </button>
  );
}

export default AnalyticsButton;
